import { render } from "./share.vue?vue&type=template&id=4f19ce80&scoped=true"
import script from "./share.vue?vue&type=script&lang=js"
export * from "./share.vue?vue&type=script&lang=js"

import "./share.vue?vue&type=style&index=0&id=4f19ce80&scoped=true&lang=css"

import exportComponent from "D:\\1FE\\7律师\\share\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f19ce80"]])

export default __exports__